import { DateTime } from "luxon";

import { dashboardsAjax } from "../../../ajax/DashboardsAjax";
import { ErrorResponse } from "../../../DTOs/Common/ErrorResponse";
import { TripleShift } from "../../../types/Shift";

const LIVE = {
  refetchInterval: 30_000,
  refetchIntervalInBackground: false,
} as const;

/**
 * The cards that read a dataset and the Targets card that compares against it share one cache entry,
 * so the fetch belongs here rather than in whichever card happens to be on screen. Tiles are granted
 * one by one, so a card declaring its own copy would go unpolled whenever the owning tile is hidden.
 */
export const plantStatusQuery = (date: DateTime, shift: TripleShift, fullDay: boolean) => ({
  queryKey: ["dashboard", "plantStatus", date.toISODate(), shift, ...(fullDay ? ["full-day"] : [])],
  queryFn: async () => {
    const res = await dashboardsAjax.getPlantStatusCardData(date, shift, fullDay);
    return ErrorResponse.isErrorResponse(res) ? null : res;
  },
  ...LIVE,
});

export const materialMovementQuery = (date: DateTime, shift: TripleShift) => ({
  queryKey: ["dashboard", "materialMovement", date.toISODate(), shift],
  queryFn: async () => {
    const res = await dashboardsAjax.getMaterialMovementCardData(date, shift);
    return ErrorResponse.isErrorResponse(res) ? null : res;
  },
  ...LIVE,
});
